import useApi from 'vl-common/src/hooks/useApi';
import React, { useEffect, useState } from 'react';
import { tools } from 'vl-common/src/lib/service.tools';
import { useTranslation } from 'react-i18next';

// display an iconic rendition of a user based on their profile photo or suitable image if none is available
export const UserAvatar = ({ user_guid }) => {
  const { t } = useTranslation('common');
  const { Api } = useApi();
  const [avatar, setAvatar] = useState('');

  useEffect(() => {
    Api.file
      .getAvatar({ user_guid })
      .then((res) => {
        const { data } = res;
        const _avatar = tools.imageBase64AWSFixer(data.base64, data.ContentType);
        setAvatar(_avatar);
      })
      .catch((_) => {
        setAvatar('');
      });
  }, [user_guid]);

  return (
    <div className="dr-part">
      {avatar && <img alt={t('avatar')} className="image" src={avatar} />}
      {!avatar && <div className="image" />}
    </div>
  );
};

export default UserAvatar;
